import { render } from "./promotionPartner.vue?vue&type=template&id=29e200e8&scoped=true"
import script from "./promotionPartner.vue?vue&type=script&lang=js"
export * from "./promotionPartner.vue?vue&type=script&lang=js"

import "./promotionPartner.vue?vue&type=style&index=0&id=29e200e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e200e8"]])

export default __exports__